import { Box, colors } from "@mui/material";
import styled from "styled-components";
import { Circle } from "@mui/icons-material";

export const SettingsContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	position: relative;
	height: 100%;

	.setting_item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 10px;
		&.row {
			flex-direction: row;
		}
		&.column {
			flex-direction: column;
		}
		.setting_label {
			font-family: var(--openSans), sans-serif;
			font-size: 18px;
		}
		.setting_value {
			display: flex;
			flex-direction: column;
			.setting_circle {
				width: 12px;
			}
			p {
				font-family: var(--poppins), sans-serif;
				font-size: 14px;
				color: ${props => props.theme.palette.text.secondary};
			}
		}
		.action {
			button {
				font-weight: bold;
				width: fit-content;
			}
		}
	}
	.info {
		background: ${colors.grey[300]};
		border: 5px;
		padding: 10px;
		h6 {
			font-size: 16px;
			font-weight: bold;
		}
	}
`;

export const StyleCircle = styled(Circle)<{ $color: string }>`
	width: 12px;
	color: ${({ $color }) => $color};
`;
